module.exports = __webpack_public_path__ + "img/guanbi.fw.11c4ff1a.png";